// extracted by mini-css-extract-plugin
export default {"loginInfo":"loginInfo-Icvm6","form":"form-HH_WJ","label":"label-HmYxT","mainLabel":"mainLabel-mYo6h"};